const configured = process.env.REACT_APP_DEXSCREENER_PAIR_URL;
if (!configured) throw new Error("Missing REACT_APP_DEXSCREENER_PAIR_URL");
const pair = new URL(configured);
if (pair.protocol !== "https:" || pair.hostname !== "dexscreener.com" || pair.port || pair.username || pair.password || !/^\/solana\/[a-z0-9]{32,44}$/.test(pair.pathname) || pair.search || pair.hash) {
  throw new Error("Invalid DexScreener Solana pair URL");
}

// Keep the owner's DexScreener path verbatim; it is not a case-sensitive mint lookup.
export const DEXSCREENER_PAIR_URL = pair.href;
pair.search = new URLSearchParams({
  embed: "1", theme: "dark", chartTheme: "dark", chartType: "usd", chartStyle: "1",
  interval: "15", info: "0", trades: "0", tabs: "0", chartLeftToolbar: "0", loadChartSettings: "0",
}).toString();
export const DEXSCREENER_EMBED_URL = pair.href;